import { writable } from 'svelte/store';

export function createMenuState(initialState = {}) {
    const { subscribe, set, update } = writable({
        isOpen: false,
        position: { x: 0, y: 0 },
        query: '',
        ...initialState
    });

    return {
        subscribe,
        open: (position) => update(state => ({ 
            ...state, 
            isOpen: true,
            position,
            query: ''
        })),
        close: () => update(state => ({ 
            ...state, 
            isOpen: false,
            query: ''
        })),
        updateQuery: (query) => update(state => ({ 
            ...state, 
            query 
        })),
        reset: () => set({
            isOpen: false,
            position: { x: 0, y: 0 },
            query: '',
            ...initialState
        })
    };
}

export const blockMenuStore = createMenuState();
export const figureMenuStore = createMenuState();
